<template>
  <div>

    <TotalizadoresComponent 
      :listaDeBacklogMacroprocessos="macroProcessos"
      :selectedBoxId="selectedBoxId"
      @emitBoxClick="recebeBoxClick"
    />

    <div class="d-block mt-5 mb-5" v-if="exibirTabelaTotal">
      <TabelaTotalComponent         
        :lista="[listaDeBacklogDesativacaoMacroprocessos.total]"
        @detalharTarefasEmit="detalharTarefasSelecao"
        :descricaoTitulo="'Total'"
        :descricaoTabela="getTituloTabTotal()"
        :mostrarCancelamento="false"
      />
    </div>

    <SGPLoadingComponent v-if="loadingBacklog" />
    
    <div class="d-block mt-5 mb-5" v-if="!loadingBacklog && !exibirTabelaTotal">
      <span v-if="processos && mostrarListaDeProcesso">
        <v-row align="center">
          <v-col cols="auto">
            <span class="font-weight-bold"> Visualizar por:</span>
          </v-col>
          <v-col>
            <SGPRadioGroupComponent
                titulo="Visualizar por:"
                :options="tiposVisualizacao"
                v-model="tipoVisualizacao"
                row>
            </SGPRadioGroupComponent>
          </v-col>
        </v-row>
      </span>

      <span v-if="tipoVisualizacao == 1"><!--visualização por status -->
        <span v-if="!formSeletores.interrupcoes && processos && mostrarListaDeProcesso">
          <!-- tarefas de esteira -->
          <v-data-table
            :headers="getHeaders()"
            :items="processos || listaTarefasBacklogDesativacao.itens"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            expanded-button="text-red"
            item-key="item"
            show-expand
            class="custom_table elevation-4"
            item-class="bg-error"
            hide-default-footer
            disable-sort

          >
            <template v-slot:body.prepend>
              <tr>
                <td>                                          
                  <v-icon v-if="!btnExpandProcessos" @click="expandAllProcessos(processos || listaTarefasBacklogDesativacao.itens)">                
                    v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light
                  </v-icon>
                  <v-icon v-else @click="expandAllProcessos(processos || listaTarefasBacklogDesativacao.itens)">                
                    v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light v-data-table__expand-icon--active
                  </v-icon>                           
                </td>
                <td>
                  {{ macroProcessoSelecionado.macro_processo }}
                </td>
                <td class="text-center">
                  <span class="cursor-pointer" @click="detalharTarefas($event,null,null,1,0,0,null)">{{ listaTarefasBacklogDesativacao.totais.qtd_tarefas_atendimento }}</span>
                </td>
                <td class="text-center">
                </td>            
                <td class="text-center">
                  {{ listaTarefasBacklogDesativacao.totais.percentual_tarefas_fora_sla }} 
                </td>            
                <td class="text-center">
                  <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,1,0,null)">
                    {{ listaTarefasBacklogDesativacao.totais.qtd_tarefas_interrompidas }}
                  </span>
                </td>
                <!-- <td class="text-center" v-if="!formSeletores.cancelamento_recadastro">
                  <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,1,null)">{{ listaTarefasBacklogDesativacao.totais.qtd_tarefas_em_cancelamento }}</span>
                </td> -->
                <td class="text-center">
                  <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,0,null)">{{ listaTarefasBacklogDesativacao.totais.qtd_tarefas_total }}</span>
                </td>
                <td>
                </td>
              </tr>
            </template>

            <template v-slot:item.qtd_tarefas_atendimento="{ item }">
              <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id,null,1,0,0,null)">{{ item.qtd_tarefas_atendimento }}</span>
            </template>
            <template v-slot:item.qtd_tarefas_interrompidas="{ item }">
              <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id,null,0,1,0,null)">{{ item.qtd_tarefas_interrompidas }}</span>
            </template>
            <!-- <template v-slot:item.qtd_tarefas_em_cancelamento="{ item }">
              <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id,null,0,0,1,null)">{{ item.qtd_tarefas_em_cancelamento }}</span>
            </template> -->
            <template v-slot:item.qtd_tarefas_total="{ item }">
              
              <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id,null,0,0,0,null)">{{ item.qtd_tarefas_total }}</span>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="tabela_tarefas_status_td">   
                <v-data-table
                  :headers="getHeaderTabelaTarefas()"
                  :items="item.tarefas"
                  hide-default-header
                  hide-default-footer
                  class="custom_table_tarefas principal tabela-desativacao"
                  :calculateWidths="true"
                  disable-pagination
                >
                  <template v-slot:item.ctrl_tarefa_id="{ item }">
                    <a
                      :href="$router.resolve({ path: `/workflow/filas-tarefas/${item.ctrl_tarefa_id}` }).href"
                      target="_blank"
                      class="decoration-none"
                    >
                      <v-icon
                        middle
                        color="error darken-1"
                      >
                        mdi-eye
                      </v-icon>
                    </a>
                  </template>

                  <template v-slot:item.qtd_tarefas_atendimento="{ item }">
                    <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,1,0,0,null)">
                      {{ item.qtd_tarefas_atendimento }}
                    </span>
                  </template>

                  <template v-slot:item.qtd_tarefas_interrompidas="{ item }">
                    <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,1,0,null)">
                      {{ item.qtd_tarefas_interrompidas }}
                    </span>
                  </template>

                  <!-- <template v-slot:item.qtd_tarefas_em_cancelamento="{ item }">
                    <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,1,null)">
                      {{ item.qtd_tarefas_em_cancelamento }}
                    </span>
                  </template> -->

                  <template v-slot:item.qtd_tarefas_total="{ item }">
                    <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,0,null)">
                      {{ item.qtd_tarefas_total }}
                    </span>
                  </template>

                </v-data-table>
              </td>
            </template>
          </v-data-table>

          <div v-if="mostrarImg" class="d-block text-center mt-15">
            <img src="@/assets/selecione-macroprocesso.svg" >
          </div>
        </span>
        <span v-else> 
          <!-- tarefas de interrupção -->
          <v-data-table
            v-if="interrupcoes && this.formSeletores.interrupcoes && mostrarListaInterrupcoes"
            :headers="headersInterrupcoes"
            :items="interrupcoes.itens || listaTarefasBacklogInterrupcoes"
            :single-expand="singleExpand"
            :expanded.sync="expandedInterrupcoes"
            expanded-button="text-red"
            item-key="item"
            show-expand
            class="custom_table elevation-4"
            item-class="bg-error"
            hide-default-footer
            disable-sort
            disable-pagination
          >                  
            <template v-slot:body.prepend>
              <tr>
                <td>  
                  <v-icon v-if="!btnExpandInterrupcoes" @click="expandAllInterrupcoes(interrupcoes.itens || listaTarefasBacklogInterrupcoes)">                
                    v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light
                  </v-icon>
                  <v-icon v-else @click="expandAllInterrupcoes(interrupcoes.itens || listaTarefasBacklogInterrupcoes)">                
                    v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light v-data-table__expand-icon--active
                  </v-icon>                           
                </td>
                <td>
                  Tarefas de Interrupção              
                </td>            
                <td class="text-center">
                  <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,0,null,1,null)">{{ interrupcoes.totais.qtd_tarefas_total }}</span>
                </td>
                <td>              
                </td>
                <td class="text-center">
                  {{ interrupcoes.totais.percentual_fora_sla }}
                </td>
                <td>              
                </td>
              </tr>
            </template>
            
            <template v-slot:item.qtd_tarefas_total="{ item }">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,0,null,1,item.ctrl_familia_id)">{{ item.qtd_tarefas_total }}</span>
            </template>
            <template v-slot:expanded-item="{ headers, item }" v-if="interrupcoes.itens.length > 0">
              <td :colspan="headers.length" class="tabela_tarefas_status_td">          
                <v-data-table                    
                  :headers="headerTabelaTarefasInterrupcoes"
                  :items="item.tarefas"
                  hide-default-header
                  hide-default-footer
                  class="custom_table_tarefas interrupcoes"
                  :calculateWidths="true"
                  disable-pagination
                >            
              
                  <template v-slot:item.qtd_tarefas_total="{ item }">
                    <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,0,null,1,null)">{{ item.qtd_tarefas_total }}</span>
                  </template>

                  <template v-slot:item.ctrl_tarefa_id="{ item }">
                    <a
                      :href="$router.resolve({ path: `/workflow/filas-tarefas/${item.ctrl_tarefa_id}` }).href"
                      target="_blank"
                      class="decoration-none"
                    >
                      <v-icon
                        middle
                        class="mr-6"
                        color="error darken-1"
                      >
                        mdi-eye
                      </v-icon>
                    </a>
                  </template>
                </v-data-table> 
            </td>      
          </template>
        </v-data-table>
      </span>
    </span>
    <span v-else> 
      <!--visualização por aging -->
        <span v-if="!formSeletores.interrupcoes && processos && mostrarListaDeProcesso">
          <TabelaAgingComponent
            :lista="listaTarefasBacklogDesativacao"
            @detalharTarefasEmit="detalharTarefasSelecao"
            :descricaoTitulo="macroProcessoSelecionado.macro_processo"
            :descricaoTabela="'Processo'"
          />
          <div v-if="mostrarImg" class="d-block text-center mt-15">
            <img src="@/assets/selecione-macroprocesso.svg" >
          </div>
        </span>
        <span v-else>
          <TabelaAgingComponent
            v-if="interrupcoes && this.formSeletores.interrupcoes && mostrarListaInterrupcoes"
            :lista="interrupcoes"
            @detalharTarefasEmit="detalharTarefasSelecao"
            :descricaoTitulo="'Tarefas de Interrupção'"
            :descricaoTabela="'Família'"
          />
          <div v-if="mostrarImg" class="d-block text-center mt-15">
            <img src="@/assets/selecione-macroprocesso.svg" >
          </div>
        </span>
    </span>

    </div>

    <ModalDetalheTarefasComponent 
        v-if="abrirModalAnalitico"
        :filtrosTarefas="filtrosTarefas"
        :key="keyModalTarefas"
        @sgpModalFechar="abrirModalAnalitico"
     />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ModalDetalheTarefasComponent from '../components/ModalDetalheTarefasComponent.vue'
import TabelaAgingComponent from '../components/TabelaAgingComponent.vue'
import TotalizadoresComponent from '../components/TotalizadoresComponent.vue'
import { getRegionaisDoUsuario, getParametrosVaziosFiltrosTarefas } from '@/common/helpers/FiltroAvancado.js'
import TabelaTotalComponent from '../components/TabelaTotalComponent.vue'

export default {
  name: "BacklogDesativacaoPage",
  components: { 
    ModalDetalheTarefasComponent,
    TabelaAgingComponent,
    TotalizadoresComponent,
    TabelaTotalComponent
  },

  props: {
    formSeletores: {
      type: Object,
      required: true,
    },
    filtroAvancado: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      filtroPayload: {
        desativacao: 1
      },
      singleExpand: false,
      btnExpandProcessos: false,
      expanded: [],
      btnExpandInterrupcoes: false,
      expandedInterrupcoes: [],
      selectedBoxId: 0,
      macroProcessoSelecionado: {},
      processos: [],
      interrupcoes: {},
      houveMudancaFiltro: false,
      abrirFiltroAvancado: false,
      mostrarImg: true,
      mostrarListaDeProcesso: false,
      mostrarListaInterrupcoes: false,
      tipoVisualizacao: 1,
      tiposVisualizacao: [
        {label: 'Status', value: 1, class: 'mr-15'},
        {label: 'Aging', value: 2},
      ],
      abrirModal: false,
      filtrosTarefas: getParametrosVaziosFiltrosTarefas(),
      keyModalTarefas: 0,
      exibirTabelaTotal: false,
      abrirModalAnalitico: false
    }
  },

  async created () {
    // this.setParametrosFiltroPayload();
    await this.filtrarMacroprocessosDaDesativacao();
 },

  computed: {
    ...mapGetters('backlog', [
      'listaDeBacklogMacroprocessos',
      'loadingBacklog',
      'listaTarefasBacklog',
      'listaTarefasBacklogInterrupcoes',
      'listaDeBacklogDesativacaoMacroprocessos',
      'listaTarefasBacklogDesativacao'
    ]),
    macroProcessos () {
      if (this.listaDeBacklogDesativacaoMacroprocessos && 
          typeof this.listaDeBacklogDesativacaoMacroprocessos.total != 'undefined' &&
          typeof this.formSeletores != 'undefined' && this.formSeletores.interrupcoes == true) {
            return {
                ...this.listaDeBacklogDesativacaoMacroprocessos,
                detalhado: this.listaDeBacklogDesativacaoMacroprocessos.detalhado.map(macro => {
                  if (!macro.macro_processo) {
                    macro.macro_processo = "DESATIVAR SERVIÇO"
                  }
                  return macro
                })
            }
      }

      return this.listaDeBacklogDesativacaoMacroprocessos
    },
    headers() {
      let widthCollumns = this.$vuetify.breakpoint.width > 1367 ? 150 : 138;
      const collums = [
        { 
          text: 'Processo',
          align: 'start',
          value: 'item',
          width: 250
        },
        { 
          text: 'Em atendimento',
          align: 'center',
          value: 'qtd_tarefas_atendimento',
          width: widthCollumns
        },
        { 
          text: 'SLA Tarefa',
          align: 'center',
          value: '',
          width: widthCollumns
        },
        { 
          text: 'Fora SLA %',
          align: 'center',
          value: 'percentual_tarefas_fora_sla',
          width: widthCollumns
        },
        { 
          text: 'Interrompidas',
          align: 'center',
          value: 'qtd_tarefas_interrompidas',
          width: widthCollumns
        },
        { 
          text: 'Total',
          align: 'center',
          value: 'qtd_tarefas_total',
          width: widthCollumns
        },
        { 
          text: '',
          align: 'center',
          value: '',
        }
      ]

      return collums
    },

    headerTabelaTarefas () {
      return [
        { 
          text: 'Processo',
          align: 'start',
          value: 'tarefa',
          width: '360px'         
        },
        { 
          text: 'Em atendimento',
          align: 'center',
          value: 'qtd_tarefas_atendimento',
          width: '360px'      
        },
        { 
          text: 'SLA Tarefa',
          align: 'center',
          value: 'sla_tarefa',
          width: '360px'      
        },
        { 
          text: 'Fora SLA%',
          align: 'center',
          value: 'percentual_tarefas_fora_sla'
          
        },
        { 
          text: 'Interrompidas',
          align: 'center',
          value: 'qtd_tarefas_interrompidas'          
        },
        // { 
        //   text: 'Em Cancelamento',
        //   align: 'center',
        //   value: 'qtd_tarefas_em_cancelamento'          
        // },
        { 
          text: 'Total',
          align: 'center',
          value: 'qtd_tarefas_total'          
        },
        { 
          text: '',
          align: 'center',
          value: 'ctrl_tarefa_id'
        }
      ]
    },

    headerTabelaTarefasInterrupcoes () {
      return [
        { 
          text: 'Tarefa',
          align: 'start',
          value: 'tarefa',
          width: this.$vuetify.breakpoint.width > 1367 ? 350 : 358         
        },        
        { 
          text: 'Em atendimento',
          align: 'center',
          value: 'qtd_tarefas_total',
          width: this.$vuetify.breakpoint.width > 1367 ? 174 : 174
        },
        { 
          text: 'SLA Tarefa',
          align: 'center',
          value: 'sla_tarefa',
          width: this.$vuetify.breakpoint.width > 1367 ? 174 : 174
        },
        { 
          text: 'Fora SLA%',
          align: 'center',
          value: 'percentual_fora_sla',
          width: this.$vuetify.breakpoint.width > 1367 ? 174 : 174
        },
        { 
          text: '',
          align: 'center',
          value: 'ctrl_tarefa_id',
          width: this.$vuetify.breakpoint.width > 1367 ? 174 : 174
        }        
      ]
    },

    headersInterrupcoes () {
      return [
        { 
          text: 'Família',
          align: 'start',
          value: 'item'
        },        
        { 
          text: 'Em atendimento',
          align: 'center',
          value: 'qtd_tarefas_total',
          width: 174
        },
        { 
          text: 'SLA Tarefa',
          align: 'center',
          value: '',
          width: 174    
        },
        { 
          text: 'Fora SLA %',
          align: 'center',
          value: 'percentual_tarefas_fora_sla',
          width: 174
        },
        { 
          text: '',
          align: 'center',
          value: '',
          width: 174
        },
      ]
    },
  },

  methods: {
    ...mapActions('backlog',[    
      'filtrarBacklogMacroprocessos',
      'filtrarBacklogTarefasMacroprocessos',
      'filtrarBacklogTarefasInterrupcoes',
      'filtrarBacklogDesativacaoMacroprocessos',
      'filtrarBacklogTarefasDesativacaoMacroprocessos'
    ]),

    setParametrosFiltroPayload () {
      if(localStorage.filtroAvancado) {
        this.filtroPayload = JSON.parse(localStorage.filtroAvancado)
      }else {
        this.filtroPayload = {
          ...this.formSeletores,
          ...{
            ctrl_regional_id: getRegionaisDoUsuario(),
          }
        } ;
      } 
    },

    async recebeBoxClick (val) {
      this.macroProcessoSelecionado = val
      let objFiltro = {
          ...this.filtroPayload,
          ...this.filtroAvancado,
          ...this.formSeletores,
          ctrl_processo_id: (val != 'total') ? val.ctrl_macro_processo_id : '',
          total: val === 'total'
      }

      if(this.formSeletores.interrupcoes) {
        this.aplicarFiltroInterrupcoes(objFiltro)
        this.mostrarListaDeProcesso = false;
        this.mostrarImg = false;
        this.mostrarListaInterrupcoes = true;
      }

      this.mostrarListaDeProcesso = true;
      this.exibirTabelaTotal = false;
      this.mostrarImg = false;

      if (val === 'total' ) {
        this.exibirTabelaTotal = true;
        return
      }

      await this.filtrarBacklogTarefasDesativacaoMacroprocessos(objFiltro)
    },

    getTituloTabTotal() {
      if (this.formSeletores.interrupcoes && this.mostrarListaInterrupcoes) {
         return 'Família'
      }

      return 'Processo'
    },

    expandAllProcessos (items) {                  
      if (!this.btnExpandProcessos) {
        this.expanded = items        
      } else {
        this.expanded = []
      }
      this.btnExpandProcessos = !this.btnExpandProcessos
    },

    getHeaders () {
      let headersAtual = this.headers;

      if(this.formSeletores.cancelamento_recadastro) {
        return headersAtual.reduce((acumulador, valorAtual) => {
          if(valorAtual.text != 'Em Cancelamento') {          
            acumulador.push(valorAtual);          
          }  
          return acumulador
        }, [])  
      } else {
        return headersAtual;
      }
    },

    getHeaderTabelaTarefas () {          
      let headersAtual = this.headerTabelaTarefas;

      if(this.formSeletores.cancelamento_recadastro) {
        return headersAtual.reduce((acumulador, valorAtual) => {         
          if(valorAtual.text != 'Em Cancelamento') {          
            if(valorAtual.value == 'ctrl_tarefa_id') {
              acumulador.push({        
                text: '',
                align: 'center',
                value: ''        
              })  
            }          
            acumulador.push(valorAtual);            
          }  
          return acumulador
        }, [])  
      } else {
        return headersAtual;
      }       
    },

    async filtrarMacroprocessosDaDesativacao () {
      if(typeof this.formSeletores == 'undefined') {
        this.formSeletores = null;
      }

      let objFiltro = {
          ...this.filtroPayload,
          ...this.filtroAvancado,
          ...this.formSeletores
      }

      await  this.filtrarBacklogDesativacaoMacroprocessos(objFiltro)
    },

    detalharTarefas (event, ctrlProcesso,ctrlTarefa,emAtendimento,interrompida,emCancelamento,aging, flagInterrupcao=false,ctrlFamiliaId=null) {
      if(typeof event == 'undefined'){
        return false;
      }

      this.setParametrosFiltrosTarefas(
        ctrlProcesso,
        ctrlTarefa,
        emAtendimento,
        interrompida,
        emCancelamento,
        aging,
        flagInterrupcao,
        ctrlFamiliaId
      );
      this.keyModalTarefas += 1;
      this.abrirModalAnalitico = true
    },

    setParametrosFiltrosTarefas (ctrlProcesso,ctrlTarefa,emAtendimento,interrompida,emCancelamento,aging,flagInterrupcao, ctrlFamiliaId) {
      this.filtrosTarefas = {
        ...this.filtroAvancado,
        ...this.formSeletores,
        item: { 
          ctrlMacroProcessoId: this.macroProcessoSelecionado.ctrl_macro_processo_id,
          ctrlProcessoId: ctrlProcesso,
          ctrlTarefaId: ctrlTarefa,
          emAtendimento: emAtendimento,
          interrompida: interrompida,
          emCancelamento: emCancelamento,
          aging: aging,
          flagInterrupcao: flagInterrupcao,
          ctrlFamiliaId: ctrlFamiliaId,
          desativacao: 1
        },
        ...this.filtroPayload
      };
    },

    detalharTarefasSelecao(obj) {
      this.detalharTarefas (
        obj.event,
        obj.ctrlProcesso,
        obj.ctrlTarefa,
        obj.emAtendimento,
        obj.interrompida,
        obj.emCancelamento,
        obj.aging,
        this.formSeletores.interrupcoes,
        obj.ctrlFamiliaId
      );
    },

    filterInterrupcoes () {
      this.interrupcoes = this.listaTarefasBacklogInterrupcoes
    },

    async aplicarFiltroInterrupcoes(dados) {      
      if(this.formSeletores.interrupcoes)
        await this.filtrarBacklogTarefasInterrupcoes(dados)
      this.filterInterrupcoes()
    },

    expandAllInterrupcoes (items) {            
      if (!this.btnExpandInterrupcoes) {
        this.expandedInterrupcoes = items
      } else {
        this.expandedInterrupcoes = []
      }
      this.btnExpandInterrupcoes = !this.btnExpandInterrupcoes
    },    
  },

  watch: {
    listaTarefasBacklogDesativacao (val) {
      this.processos = val.itens
    },

    formSeletores () {
      this.filtrarMacroprocessosDaDesativacao()
    },

    filtroAvancado () {
      this.filtrarMacroprocessosDaDesativacao()
    }
  }
}

</script>

<style lang="scss">
$redColor: #000;
$fontSizeSlaInterromp: 9px;

.custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(1) {
  width: 112px !important;  
}

.custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(2) {
  width: 60px !important;
}
.custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(3) {
  width: 70px !important;
}

.custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(4) {
  width: 80px !important;
}
.custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(5) {
  width: 60px !important;
}

.custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(6) {
  width: 80px !important;
}

.custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(7) {
  width: 144px !important;
}

@media screen and (min-width: 1367px) {
  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(1) {
    width: 182px !important; 
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(2) {
    width: 80px !important;
  }
  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(3) {
    width: 90px !important;
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(4) {
    width: 120px !important;
  }
  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(5) {
    width: 80px !important;
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(6) {
    width: 108px !important;
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(7) {
    width: 206px !important;
  }
}

@media screen and (min-width: 1600px) {
  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(1) {
    width: 150px !important; 
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(2) {
    width: 80px !important;
  }
  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(3) {
    width: 90px !important;
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(4) {
    width: 100px !important;
  }
  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(5) {
    width: 80px !important;
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(6) {
    width: 96px !important;
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(7) {
    width: 282px !important;
  }
}

@media screen and (min-width: 1800px) {
  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(1) {
    width: 130px !important;  
    min-width: 140px !important;
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(2) {
    width: 80px !important;
  }
  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(3) {
    width: 70px !important;
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(4) {
    width: 100px !important;
  }
  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(5) {
    width: 80px !important;
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(6) {
    width: 90px !important;
  }

  .custom_table_tarefas.principal.tabela-desativacao tbody tr td:nth-child(7) {
    width: 376px !important;
  }
}
</style>